import React from "react";

import FormResetPassword from "../components/formResetPassword";
import OnBoardingLayout from "../components/on-boarding-layout";

export default function ResetPassword() {
  return <OnBoardingLayout screen={<FormResetPassword />} />;
}
